import { render, staticRenderFns } from "./CollectStat.vue?vue&type=template&id=b90b4f6e&"
import script from "./CollectStat.vue?vue&type=script&lang=js&"
export * from "./CollectStat.vue?vue&type=script&lang=js&"
import style0 from "./CollectStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports